var _style, _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _path3, _polygon5, _polygon6, _path4, _path5, _polygon7, _path6, _path7, _polygon8, _polygon9, _polygon10, _polygon11, _path8, _polygon12, _polygon13, _path9, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _path10, _path11, _path12, _polygon23, _path13, _polygon24, _polygon25, _polygon26, _polygon27, _path14, _polygon28, _path15, _path16, _path17, _path18, _path19, _path20, _polygon29, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _rect, _path29, _path30, _path31, _polygon30, _path32, _rect2, _path33, _polygon31, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _polygon32;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrvfLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.st1{fill:#ED372A;}\n\t.st2{fill:#FDC428;}\n\t.st3{fill:#F79925;}\n\t.st4{fill:#7EBD42;}\n\t.st5{fill:#41BAAE;}\n\t.st6{fill:#673128;}\n\t.st7{fill:#637332;}\n\t.st8{fill:#672C27;}\n\t.st9{fill:#B82C8F;}\n\t.st10{fill:#BB2E33;}\n\t.st11{fill:#692F29;}\n\t.st12{fill:#672F28;}\n\t.st13{fill:#672D28;}\n\t.st14{fill:#EC6F98;}\n\t.st15{fill:#EE602D;}\n\t.st16{fill:#EE5327;}\n\t.st17{fill:#ED4828;}\n\t.st18{fill:#653E28;}\n\t.st19{fill:#682628;}\n\t.st20{fill:#663828;}\n\t.st21{fill:#682728;}\n\t.st22{fill:#BA2232;}\n\t.st23{fill:#A9212C;}\n\t.st24{fill:#BA202E;}\n\t.st25{fill:#572527;}\n\t.st26{fill:#562526;}\n\t.st27{fill:#382926;}\n\t.st28{fill:#0C8CC9;}\n\t.st29{fill:#0F8542;}\n\t.st30{fill:#062E25;}\n\t.st31{fill:#092B24;}\n\t.st32{fill:#0C2924;}\n\t.st33{fill:#0C2823;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.4,0h1769.1c41.7,0,75.4,33.8,75.4,75.4v927.1c0,41.7-33.8,75.4-75.4,75.4H75.4c-41.7,0-75.4-33.8-75.4-75.4 V75.4C0,33.8,33.8,0,75.4,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M537.4,307.8l-21,105.4c1.9,24.3,4.9,51.3,9.2,79.7l28.8-43.1L581,316.5L537.4,307.8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "272.1,484.9 263.4,528.5 396.7,555.1 453.8,543.8 405.5,511.5 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "624.8,555.2 567.8,566.5 616.1,598.8 749.4,625.4 758.1,581.8 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "704.5,399.1 591.4,474.6 559.1,522.9 616.1,511.5 729.2,436.1 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "462.4,587.4 405.4,598.7 292.3,674.2 317,711.2 430.1,635.7 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M551.7,609.3c18.2,59.3,44.7,116.6,83.5,160.7l31.6-21.1l-75.5-113.1L551.7,609.3"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "391.7,336.7 354.7,361.4 430.2,474.5 478.5,506.8 467.2,449.8 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "630,336.8 554.4,449.8 543.1,506.8 591.4,474.6 667,361.5 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M470.4,608.8l-40.3,26.9l-75.6,113l32.1,21.5C425.5,726,452.2,668.4,470.4,608.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M554.5,449.8l-28.8,43.1c1.2,7.6,2.5,15.3,3.8,23l13.6-9.1L554.5,449.8"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "591.4,474.6 543.1,506.8 539.1,526.8 559.1,522.9 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M477.4,584.4l-15,3l-32.3,48.3l40.3-26.9C472.9,600.7,475.2,592.6,477.4,584.4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M543.1,506.8l-13.6,9.1c0.7,4.1,1.5,8.2,2.3,12.4l7.3-1.5L543.1,506.8"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "559.1,587.5 591.3,635.8 704.3,711.4 729.1,674.4 616.1,598.8 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "317.2,398.9 292.4,435.9 405.5,511.5 462.5,522.8 430.2,474.5 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "405.5,511.5 453.8,543.8 473.8,539.8 462.5,522.8 "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "567.8,566.5 547.7,570.5 559.1,587.5 616.1,598.8 "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M544.7,584.6c2.2,8.3,4.6,16.5,7.1,24.7l39.6,26.5l-32.3-48.3L544.7,584.6"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "430.2,474.5 462.5,522.8 482.5,526.8 478.5,506.8 "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "462.5,522.8 473.8,539.8 484.6,537.7 482.5,526.8 "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M547.7,570.5l-6.4,1.3c1.1,4.3,2.2,8.5,3.3,12.8l14.4,2.9L547.7,570.5"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "749.5,485.1 616.1,511.5 567.8,543.8 624.8,555.2 758.1,528.7 "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "396.7,555.1 396.7,555.1 263.4,581.5 272,625.2 405.4,598.7 453.7,566.5 "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "567.8,543.8 550.8,555.2 567.8,566.5 624.8,555.2 "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "453.8,543.8 453.8,543.8 396.7,555.1 453.7,566.5 470.7,555.1 "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "453.7,566.5 453.7,566.5 405.4,598.7 462.4,587.4 473.8,570.4 "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "616.1,511.5 559.1,522.9 547.8,539.8 567.8,543.8 "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "547.8,539.8 541.6,549 550.8,555.2 567.8,543.8 "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "470.7,555.1 470.7,555.1 453.7,566.5 473.8,570.4 479.9,561.3 "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "559.1,522.9 539.1,526.8 536.9,537.7 547.8,539.8 "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M473.8,570.4L473.8,570.4l-11.3,17l15-3c1.1-4.2,2.2-8.4,3.2-12.6L473.8,570.4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M539.1,526.8l-7.3,1.5c0.6,2.9,1.1,5.8,1.7,8.7l3.4,0.7L539.1,526.8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M479.9,561.3L479.9,561.3l-6.1,9.2l6.9,1.4c0.7-2.9,1.4-5.8,2.1-8.7L479.9,561.3"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "536.9,537.7 536.9,537.7 535.5,544.9 541.6,549 547.8,539.8 "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M533.5,537c0.5,2.5,1.1,5.1,1.6,7.7l0.4,0.2l1.5-7.2L533.5,537"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "473.8,539.8 473.8,539.8 453.8,543.8 470.7,555.1 479.9,549 "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "550.8,555.2 550.8,555.2 541.6,561.3 547.7,570.5 567.8,566.5 "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "541.6,549 541.6,549 537.5,555.2 541.6,561.3 550.8,555.2 "
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "479.9,549 479.9,549 470.7,555.1 479.9,561.3 484,555.1 "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M541.6,561.3L541.6,561.3l-2.4,1.6c0.7,3,1.4,5.9,2.1,8.8l6.4-1.3L541.6,561.3"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "484.6,537.6 484.6,537.6 473.8,539.8 479.9,549 486,544.9 "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M486,544.9L486,544.9l-6.1,4.1l4.1,6.1l0.9-1.3c0.5-2.4,1-4.7,1.6-7L486,544.9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M537.5,555.2l-0.1,0.1c0.6,2.5,1.2,5.1,1.8,7.6l2.4-1.6L537.5,555.2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M484,555.1L484,555.1l-4.1,6.1l2.8,1.9c0.6-2.5,1.1-4.9,1.7-7.4L484,555.1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M535.5,544.9L535.5,544.9l-0.2,0.8c0.7,3.1,1.3,6.1,2,9.2l0.2,0.2l4.1-6.1L535.5,544.9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M535.1,544.7c0.1,0.3,0.2,0.7,0.2,1l0.2-0.8L535.1,544.7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M484.9,553.8l-0.9,1.3l0.4,0.6C484.6,555.1,484.7,554.5,484.9,553.8"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "537.3,554.9 537.4,555.3 537.5,555.2 "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M484.4,307.8l-43.6,8.6l26.5,133.4l29.1,43.6c4.4-28.1,7.3-54.9,9.2-79L484.4,307.8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M467.2,449.8l11.3,57l14,9.3c1.4-7.7,2.6-15.3,3.8-22.8L467.2,449.8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M478.5,506.8l4,20l7.7,1.5c0.8-4.1,1.5-8.2,2.3-12.2L478.5,506.8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M482.5,526.8l2.1,10.8l3.9-0.8c0.6-2.8,1.1-5.7,1.7-8.5L482.5,526.8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M488.5,536.9l-3.9,0.8l1.4,7.2l0.9-0.6C487.5,541.8,488,539.3,488.5,536.9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M487,544.3l-0.9,0.6l0.4,1.9C486.6,546,486.8,545.1,487,544.3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5,338.5h46.1c27.3,0,37.4,11.2,37.4,31.9v16.1c0,20.6-11,31.8-38.5,31.8h-22.7v38.3h-22.3L844.5,338.5L844.5,338.5z  M889.3,358.2h-22.5v40.5h22.5c12.6,0,16.3-4.6,16.3-14.4v-12.1C905.6,362.5,901.6,358.3,889.3,358.2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.3,432.2h-43.8l-7.5,24.5h-23.4l37.2-118.1h31.2l37.3,118.1h-23.4L1002.3,432.2L1002.3,432.2L1002.3,432.2z M964,412.9 h32.6L980.5,357L964,412.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1160.6,
    y: 338.5,
    width: 22.3,
    height: 118.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.6,458.5c-13.5,0-29.1-3.4-36.9-7.1l3.9-17.6c11,3.4,21.7,5.5,33.3,5.5c16.1,0,18.8-3.4,18.8-14.7 c0-13.1-0.4-14.2-21.6-18.8c-28.6-6.4-32.5-11.9-32.5-36.9c0-21.5,9.8-32.1,39.7-32.1c10.3,0,22.7,1.2,34.4,3.9l-2.5,18.8 c-9.8-2.1-21.3-3.5-31.6-3.5c-15.1,0-17.7,3.2-17.7,13.5c0,13.5,0.4,13.8,20.8,18.8c31.8,7.6,33.3,12.8,33.3,36.4 C1281.1,446.9,1274.5,458.5,1239.6,458.5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.4,398.3h-4.5c0,28.2,13.3,54.4,35.9,70.9l13.9-16.9c-13-9.2-22.1-22.5-26-37.6c0.4-0.1,0.7-0.2,0.7-0.2 c12.4-4.4,17.7-14.4,17.7-28.6v-15.4c0-20.8-10.1-31.9-37.6-31.9h-48.4v118.1h22.4v-98.5h25.2c11.9,0,16.1,4.1,16.1,14V384 C1111.9,393.7,1108.1,398.1,1096.4,398.3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M893.2,553.1h-4.5c0,28.5,13.5,55,36.3,71.7l14-17.1c-13.2-9.3-22.4-22.8-26.3-38c0.4-0.1,0.7-0.2,0.7-0.2 c12.6-4.5,17.9-14.5,17.9-28.9v-15.6c0-21-10.2-32.3-38-32.3h-49v119.5H867v-99.5h25.5c12,0,16.3,4.1,16.3,14.2v11.8 C908.8,548.4,904.9,552.9,893.2,553.1"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "958.8,493.1 1031.7,493.1 1031.7,513 981.3,513 981.3,541.7 1027.7,541.7 1027.7,561.5 981.3,561.5 981.3,592.3  1031.7,592.3 1031.7,612.1 958.8,612.1 "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.6,575.3c0,11.6,5,18.4,20.7,18.4c6.1,0,12.3-0.5,18.4-1.4v-36.1h21.3v52.3c-12.5,3.6-27.3,5.4-39.8,5.4 c-29.1,0-43.1-12.3-43.1-35.9v-50.7c0-24.5,14.3-35.9,45.2-35.9c9.7,0,23.4,1.1,34.1,3.9l-2.5,19.7c-10.9-2.3-21.8-3.2-33.4-3.2 c-15.7,0-20.9,6.4-20.9,18.6L1075.6,575.3L1075.6,575.3L1075.6,575.3z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1161,
    y: 493.1,
    width: 22.5,
    height: 119
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1298.5,577.3c0,19.8-11.4,36.6-45,36.6s-45-16.8-45-36.6V528c0-19.8,11.4-36.6,45-36.6s45,16.8,45,36.6V577.3z M1231,576 c0,11.2,5.7,18,22.5,18s22.5-6.8,22.5-18v-46.8c0-11.2-5.7-18-22.5-18s-22.5,6.8-22.5,18V576z"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "1344.6,521.9 1344.6,612.1 1322.7,612.1 1322.7,493.1 1352.7,493.1 1397.9,583.5 1397.9,493.1 1419.8,493.1  1419.8,612.1 1389.8,612.1 "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M869.3,656h18.1l14.3,65c2.3,10.5,5.1,26.7,6.3,33.8h0.8c1.3-6.9,4.1-22.5,6.4-33.6l14.3-65.2H947l-26.7,114.7 H896L869.3,656L869.3,656L869.3,656z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M983.2,686.1c24.8,0,30.5,15,30.5,25.8c0,15.6-3.3,22.2-22.5,22.2c-6.6,0-18.1-1.2-25-3.1v1.3 c0,19.9,5.1,25.5,18.3,25.5c9.2,0,17.1-2,24.2-4.3l3,13.2c-3,1.5-14.3,5.4-29.6,5.4c-25.8,0-33.4-13.8-33.4-43 S956.4,686.1,983.2,686.1L983.2,686.1L983.2,686.1z M986.3,721.4c9,0,10-3.8,10-9.4c0-7.2-4.3-12.2-13.5-12.2 c-10.5,0-15.6,5.6-16.3,18.4C972.3,720.1,980.2,721.4,986.3,721.4L986.3,721.4L986.3,721.4z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1029.1,688.1h15.3l1,8.2h0.7c6.3-5.3,13.8-9.7,24.7-9.7s21.7,5.3,21.7,24.9v59.3h-17.4V714 c0-9.2-3.4-12.5-9.9-12.5c-7.7,0-14.2,4.8-18.6,9.4v59.9h-17.4L1029.1,688.1L1029.1,688.1L1029.1,688.1z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1115.2,701.1h-11.8v-13h12l1.3-21.4l16.1-1.7v23h37.7l-2,13h-35.7v49.1c0,6.6,2.1,7.2,7.2,7.2 c3.9,0,10.5-1.7,11.4-1.8l2.8,13.5c-2.5,1.2-10.9,3-18.4,3c-13.7,0-20.6-3.3-20.6-21.6L1115.2,701.1L1115.2,701.1L1115.2,701.1z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1184.2,688.1v57c0,9,3.3,12.3,9.7,12.3c7.7,0,14.2-4.8,18.6-9.2v-60.1h17.6v82.6h-15.5l-1-8.2h-0.3 c-6.6,5.3-14,9.7-24.9,9.7s-21.9-5.3-21.9-24.9v-59.3L1184.2,688.1L1184.2,688.1z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1250,688.1h15.3l1,8.2h0.7c4.9-5.3,12.2-9.4,21.6-9.4c3.1,0,6.1,0.3,7.7,1l-2.5,16.1c-2.6-0.5-5.3-1-8.2-1 c-8.1,0-14.8,4.4-18.1,8.9v58.8H1250L1250,688.1L1250,688.1L1250,688.1z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1336.3,686.1c24.9,0,30.4,15,30.4,25.8c0,15.6-3.3,22.2-22.6,22.2c-6.6,0-18.1-1.2-25-3.1v1.3 c0,19.9,5.1,25.5,18.3,25.5c9.2,0,17.1-2,24.2-4.3l3,13.2c-3,1.5-14.3,5.4-29.6,5.4c-25.8,0-33.4-13.8-33.4-43 S1309.4,686.1,1336.3,686.1L1336.3,686.1L1336.3,686.1z M1339.4,721.4c9.1,0,10-3.8,10-9.4c0-7.2-4.3-12.2-13.5-12.2 c-10.5,0-15.6,5.6-16.3,18.4C1325.4,720.1,1333.3,721.4,1339.4,721.4L1339.4,721.4L1339.4,721.4z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1437.7,701.1v69.6h-17.4v-69.6h-16.6v-13h16.6v-14c0-20.1,10.2-23.4,23.4-23.4c6.4,0,19.7,1,24.7,2.1 l-2.3,13.3c-4.6-0.5-13.3-1.2-17.3-1.2c-7.2,0-11,1.2-11,10.9v12.2h39.6l-2,13H1437.7z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1486.7,688.1v57c0,9,3.3,12.3,9.7,12.3c7.7,0,14.2-4.8,18.6-9.2v-60.1h17.6v82.6h-15.5l-1-8.2h-0.3 c-6.6,5.3-14,9.7-24.9,9.7s-21.9-5.3-21.9-24.9v-59.3L1486.7,688.1L1486.7,688.1z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1552.6,688.1h15.3l1,8.2h0.7c6.3-5.3,13.8-9.7,24.7-9.7s21.7,5.3,21.7,24.9v59.3h-17.4V714 c0-9.2-3.5-12.5-9.9-12.5c-7.7,0-14.2,4.8-18.6,9.4v59.9h-17.4L1552.6,688.1L1552.6,688.1L1552.6,688.1z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1662.7,686.6c7.4,0,12.8,1.5,16.5,2.6h0.3c0,0-0.3-5.9-0.3-15.1v-22.2h17.4v118.8h-15.3l-1-8.2h-0.5 c-6.4,5.3-14.2,9.7-23.5,9.7c-15.6,0-24.8-7.7-24.8-38C1631.4,696,1643.8,686.6,1662.7,686.6L1662.7,686.6L1662.7,686.6z  M1679.2,703.4c-3.6-1.2-8.9-2-13.5-2c-11,0-16.6,4.6-16.6,30.6c0,22.2,4.4,25.3,11.8,25.3s14-4.8,18.3-9.2V703.4z"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    points: "879.5,770.8 860.9,688.5 843,688.5 861.6,770.8 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrvfLogo);
export default __webpack_public_path__ + "static/media/PRVF-logo.6d367533765404e019792b405ba50c44.svg";
export { ForwardRef as ReactComponent };